var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('AppLogo'),_c('AuthenticationForm'),_c('p',{staticClass:"footer"},[_vm._v("©2020 David Vasco")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }